module.exports = __webpack_public_path__ + "img/148eecbe3781e0b0d71157c0d73ff81d.148eecbe.png";